import ajax from '@utils/ajax'

/**
 * @module 结算中心
 * @param {*} params 
 * @api_address http://wiki.czb365.com/pages/viewpage.action?pageId=42902623
 */

const baseUrl = ''

/**
 * @submodule 结算账单明细（POS）
 */

const dailyBillUrl =  `${baseUrl}/gasstationBill`

//日账单明细  查询：账单类型
export const getDailyDetailQueryApi = params => ajax.post(`${dailyBillUrl}/queryBillDetailOrderTypeList`, params)

//日账单明细  表汇总数据
export const getDailyDetailSummaryApi = params => ajax.post(`${dailyBillUrl}/queryPosDailyDetailSummary`, params)

//日账单明细  列表
export const getDailyDetailListApi = params => ajax.post(`${dailyBillUrl}/queryPosBillDetailList`, params)

//日账单明细  导出
export const downloadDailyDetailListApi = data => ajax.post(`${dailyBillUrl}/exportPosBillDetails`,data)
